module.exports = __webpack_public_path__ + "media/images/apple-1b10ececffce8ec95d3045747126411a.svg";